import { useState } from "react"

import { fetcher } from "common/helpers/fetcher"

export type ProposalDetails = {
  title: string
  description: string
  comments: []
}

export function useImportProposalData() {
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [proposalDetails, setProposalDetails] = useState<ProposalDetails>({
    title: "",
    description: "",
    comments: [],
  })

  function importData(provider: string, url: string, callBack?: () => void) {
    setIsLoading(true)
    setProposalDetails({
      title: "",
      description: "",
      comments: [],
    })

    if (provider === "discourse") {
      fetcher
        .rest({
          endpoint: `/api/proposal/import`,
          method: "POST",
          variables: {
            provider: "discourse",
            url,
          },
          error: { skipReport: true, warning: { isSilent: true } },
        })
        .then((data: any) => {
          if (data) {
            const { title, description, comments } = data

            setProposalDetails({ title, description, comments })

            if (callBack) {
              callBack()
            }
          }

          if (!data || !data?.title) {
            setIsError(true)

            return
          }

          setIsLoading(true)
        })
        .catch(() => {
          setIsError(true)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }

    if (provider === "snapshot") {
      const extractProposalId = (url: string): string | null => {
        const pattern = /\/proposal\/([^/]+)$/

        const match = pattern.exec(url)

        return match ? match[1] : null
      }

      const proposalId = extractProposalId(url)

      if (!proposalId) return

      fetcher
        .gql({
          endpoint: `https://hub.snapshot.org/graphql`,
          query: `
            query SnapshotProposal($id: String!) {
             proposal(id: $id) {
              id
              title
              body
             }
           }
           `,
          variables: {
            id: proposalId,
          },
        })
        .then((data: any) => {
          if (data) {
            if (!data?.proposal) {
              setIsError(true)

              return
            }

            setProposalDetails({
              title: data.proposal.title,
              description: data.proposal.body,
              comments: [],
            })

            if (callBack) {
              callBack()
            }
          }

          setIsLoading(true)
        })
        .catch(() => {
          setIsError(true)
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }

  return {
    importData,
    isLoading,
    isError,
    proposalDetails,
  }
}
